import { useCallback, useState } from "react";

export const useAccordion = (startOpen = false) => {
  const [expanded, setExpanded] = useState(startOpen);
  const toggle = useCallback(() => setExpanded((v) => !v), []);
  return { expanded, toggle };
};
